/**
 * Feature flags for MVP vs Full version
 *
 * MVP Target: Private Equity Portfolio Company Executives
 * Core modules: Home, Insights, Initiatives, Team
 */

export const DEFAULT_FEATURES = {
  home: true,
  insights: true,
  initiatives: true,
  team: true,
  ideas: true,
  ai_leads: true,
  ai_workspace: false,
  knowledge_base: true,
  settings: true,
  support: true,
  guide: true,
  governance: false,
  marketplace: false,
  vendors: false,
  readiness: false,
  assessment: false,
  // Cost Management surface — Overview / Registry / Usage Analytics
  // / Budgets. Backed by ``api/app/modules/cost_management`` endpoints.
  cost_management: true,
  // ABAC authoring + decision flag. Mirrors the backend
  // DEFAULT_FEATURES entry. When false, admin policy UI is hidden and
  // policy admin endpoints return 403.
  abac: true,
  // ReBAC (discretionary resource sharing). Mirror of
  // api/app/core/features.py. Default ON; disabling hides the
  // SharesPanel and share controls on the frontend.
  rebac: true,
} as const;

// Keep backward compat alias
export const features = DEFAULT_FEATURES;

export type FeatureKey = keyof typeof DEFAULT_FEATURES;

export const isFeatureEnabled = (feature: FeatureKey): boolean => {
  return DEFAULT_FEATURES[feature];
};

/**
 * Platform branding configuration
 */
export const branding = {
  name: "misia.ai",
  tagline: "AI Adoption & Oversight",
  description: "Track, govern, and scale AI use cases safely across your organisation.",
} as const;
